import { Record, List } from 'immutable'
import { checkStatus, json, CustomerAPI } from '@driftt/dapper'
import { captureException } from 'utils/SentryHelpers'
import { CustomerAPIAuthEnabled } from 'app/auth-requests/api'

export const SlackUser = Record({
  email: undefined,
  slackUserId: undefined,
  avatarUrl: undefined,
  name: undefined,
})

function parseResponse(data) {
  const { user, slackUser } = data
  return SlackUser({
    name: user.name,
    email: user.email,
    slackUserId: slackUser.id,
    avatarUrl: slackUser.profile.image_48, // possible img suffixes _24 _32 _48 _71 _192 _512
  })
}

const SlackTeamAPI = {
  fetch() {
    return CustomerAPIAuthEnabled.get('/integrations/slack/team')
      .then(response => List(response.data).map(parseResponse))
      .catch(captureException)
  },

  sendInvitations(users, orgId, scopes) {
    /*
     * Rather than create a new endpoint for slack, we're re-using the org invite endpoint. This creates some
     * confusion  between our SlackStore and our OrgStore and who owns what. It may be worth dedicating
     * Customer API code to slack integration activity rather than doubling duty of the org API
     */
    const usersWithScopes = users.map((user) => {
      return {
        slackUserId: user.slackUserId,
        email: user.email,
        scopes: scopes
      }
    })

    return CustomerAPI.post(`/organizations/${orgId}/users/invitations/slack`, usersWithScopes)
      .then(json)
  }
}

export default SlackTeamAPI



// WEBPACK FOOTER //
// ./src/scripts/app/api/SlackTeamAPI.js